
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PATHS } from '@/routes/routePaths';

const NoBusinessFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <Card className="w-full max-w-lg shadow-lg">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">No Business Found</CardTitle>
          <CardDescription>You need to register a business before managing subscriptions.</CardDescription>
        </CardHeader>
        <CardFooter className="justify-center">
          <Button onClick={() => navigate(PATHS.REGISTER_BUSINESS)} className="bg-orange-500 hover:bg-orange-600">
            Register Business
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default NoBusinessFound;
